module.exports = __webpack_public_path__ + "static/media/pascall.81a6172f.png";